import List from './List'

export default {
  list: List
}
